export const SET_USER = 'SET_USER';
export const RESET_USER = 'RESET_USER';
